import Vue from "vue";


export default {
  updataLang(state, data) {
    state.lang = data.lang; // 语言
  },
  upUid(state, data) {
    state.uid = data.uid;
  },
  uptabs(state, data) {
    state.tabs = data.tabs;
  },
  upGMCUID(state, data) {
    state.GMCUID = data.GMCUID;
  },
  upFUNAPI(state, data) {
    state.FUNAPI = data.FUNAPI;
  },
  upISVALIDATE(state, data) {
    state.ISVALIDATE = data.ISVALIDATE;
  },
  upUserUid(state, data) {
    localStorage.setItem("userUid", data.userUid);
    state.userUid = data.userUid;
  },
    updataGrCombine(state, data) {
        // localStorage.setItem("isGrCombine", data.isGrCombine);
        state.isGrCombine = data.isGrCombine;
   },
    updataLoading(state,data) {
        state.pbLoading = data.pbLoading;
    },
    updataRole(state,data) {
        state.Role = data.Role;
    },
      updataPartStatus(state,data) {
        state.partStatus = data.partStatus;
    },
    updataTabsTitle(state,data) {
        state.tabsTitle = data.tabsTitle;
    },
    updataUseCase1(state,data) {
        state.tms.useCase1 = data.useCase1;
    },
    updataUseCase2(state,data) {
        state.tms.useCase2 = data.useCase2;
    },
    updataUseCase3(state,data) {
        state.tms.useCase3 = data.useCase3;
    },
    updataUseCase4(state,data) {
        state.tms.useCase4 = data.useCase4;
    },
    updataskeepLive(state,data) {
        state.iskeepLive = data.iskeepLive;
    },
    updataWhsCode(state,data) {
        state.whsCode = data.whsCode;
    },
  
     updateSystemParam(state,data){
       Vue.set(state,'systemParam',data)
    },
    updatatmsDrag(state,data){
        state.tmsDrag = data.tmsDrag;
    },
	updateProjectCode(state,data){
      Vue.set(state,'projectCode',data) ;//state.projectCode = data
    },
    updateSF_SCPPrint(state,SF_SCPPrint){ // SCPPrint 为SF js 的对象
        Vue.set(state,'SF_SCPPrint',SF_SCPPrint)
    }
};
